var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "mobile-navigation",
      class: { open: _vm.isMobileNavigationOpen },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNavigationInitialized,
              expression: "isNavigationInitialized",
            },
          ],
        },
        [
          _c("div", { staticClass: "mobile-navigation__head" }, [
            _c(
              "div",
              {
                staticClass: "mobile-navigation__close",
                on: {
                  click: function ($event) {
                    return _vm.closeNavigation()
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "33",
                      height: "28",
                      viewBox: "0 0 42 38",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("rect", {
                      attrs: {
                        x: "2.78809",
                        width: "50.3424",
                        height: "3.39746",
                        rx: "1.69873",
                        transform: "rotate(45 2.78809 0)",
                        fill: "#F0C42E",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        y: "35.5977",
                        width: "50.3424",
                        height: "3.39746",
                        rx: "1.69873",
                        transform: "rotate(-45 0 35.5977)",
                        fill: "#F0C42E",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "5.78809",
                        width: "50.3424",
                        height: "3.39746",
                        rx: "1.69873",
                        transform: "rotate(45 5.78809 0)",
                        fill: "#0E0F12",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "3",
                        y: "35.5977",
                        width: "50.3424",
                        height: "3.39746",
                        rx: "1.69873",
                        transform: "rotate(-45 3 35.5977)",
                        fill: "#0E0F12",
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mobile-navigation__headline" }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$translate("AbfallbehaelterXXL::Template.navPrevTitle")
                  )
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu menu-active",
              attrs: { id: "menu-1" },
            },
            [
              _vm.dataContainer1.parent
                ? _c(
                    "li",
                    {
                      staticClass: "ddown",
                      on: {
                        click: function ($event) {
                          return _vm.slideTo(
                            (_vm.dataContainer1.parent &&
                              _vm.dataContainer1.parent.parent) ||
                              null,
                            true
                          )
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "nav-direction btn-up" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "14",
                              height: "12",
                              viewBox: "0 0 14 12",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M12.6663 5.71396L2.27567 5.71396L5.85167 2.13796C6.112 1.87762 6.112 1.45546 5.85184 1.19529C5.5915 0.934957 5.16917 0.934957 4.90884 1.19529L0.195003 5.90929C0.164003 5.94029 0.136338 5.97446 0.112004 6.01079C0.100837 6.02763 0.0930028 6.04579 0.0833363 6.06329C0.0723367 6.08396 0.05967 6.10363 0.050837 6.12546C0.0413365 6.14796 0.0360036 6.17129 0.0293374 6.19463C0.0238366 6.21313 0.0166707 6.23079 0.0128369 6.24979C0.00417089 6.29313 -0.000330446 6.33679 -0.000330442 6.38063C-0.000330442 6.38113 -0.000163549 6.38163 -0.000163549 6.38213C3.34821e-06 6.42529 0.00433685 6.46863 0.012837 6.51113C0.0168367 6.53113 0.0243364 6.54963 0.03017 6.56929C0.0366702 6.59146 0.0416703 6.61396 0.0506702 6.63546C0.0603366 6.65863 0.0733371 6.67963 0.0853372 6.70146C0.094337 6.71779 0.101503 6.73446 0.111836 6.75013C0.13617 6.78696 0.164171 6.82129 0.195338 6.85246L4.90901 11.566C5.16934 11.8263 5.59151 11.8263 5.85184 11.5661C6.11217 11.3058 6.11217 10.8836 5.85184 10.6231L2.27584 7.04729L12.6663 7.04729C13.0345 7.04729 13.333 6.74879 13.333 6.38062C13.333 6.01246 13.0345 5.71396 12.6663 5.71396Z",
                                fill: "#F0C42E",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M12.6663 4.71396L2.27567 4.71396L5.85167 1.13796C6.112 0.877623 6.112 0.455457 5.85184 0.19529C5.5915 -0.0650428 5.16917 -0.0650427 4.90884 0.19529L0.195003 4.90929C0.164003 4.94029 0.136338 4.97446 0.112004 5.01079C0.100837 5.02763 0.0930028 5.04579 0.0833363 5.06329C0.0723367 5.08396 0.05967 5.10363 0.050837 5.12546C0.0413365 5.14796 0.0360036 5.17129 0.0293374 5.19463C0.0238366 5.21313 0.0166707 5.23079 0.0128369 5.24979C0.00417089 5.29313 -0.000330446 5.33679 -0.000330442 5.38063C-0.000330442 5.38113 -0.000163549 5.38163 -0.000163549 5.38213C3.34821e-06 5.42529 0.00433685 5.46863 0.012837 5.51113C0.0168367 5.53113 0.0243364 5.54963 0.03017 5.56929C0.0366702 5.59146 0.0416703 5.61396 0.0506702 5.63546C0.0603366 5.65863 0.0733371 5.67963 0.0853372 5.70146C0.094337 5.71779 0.101503 5.73446 0.111836 5.75013C0.13617 5.78696 0.164171 5.82129 0.195338 5.85246L4.90901 10.566C5.16934 10.8263 5.59151 10.8263 5.85184 10.5661C6.11217 10.3058 6.11217 9.88363 5.85184 9.62313L2.27584 6.04729L12.6663 6.04729C13.0345 6.04729 13.333 5.74879 13.333 5.38062C13.333 5.01246 13.0345 4.71396 12.6663 4.71396Z",
                                fill: "#0E0F12",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        typeof _vm.dataContainer1.parent.details !== "undefined"
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.dataContainer1.parent.details[0].name
                                )
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataContainer1.categories, function (category) {
                return _c("li", { staticClass: "ddown" }, [
                  _c(
                    "a",
                    { attrs: { href: _vm.getCategoryUrl(category.url) } },
                    [_vm._v(_vm._s(category.details[0].name))]
                  ),
                  _vm._v(" "),
                  category.childCount
                    ? _c(
                        "span",
                        {
                          staticClass: "nav-direction",
                          on: {
                            click: function ($event) {
                              return _vm.slideTo(category)
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "9",
                                height: "11",
                                viewBox: "0 0 6 8",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M5.43617 4.38461L2.44086 7.37992C2.16617 7.65461 1.7168 7.65461 1.44242 7.37992L1.19211 7.12992C0.917734 6.85586 0.917734 6.40617 1.19211 6.1318L3.47805 3.84586L1.19211 1.55961C0.917734 1.28523 0.917734 0.835547 1.19211 0.561485L1.44242 0.311484C1.7168 0.036797 2.16617 0.036797 2.44086 0.311484L5.43617 3.30742C5.58367 3.45461 5.6493 3.65242 5.63836 3.84586C5.6493 4.0393 5.58367 4.2368 5.43617 4.38461Z",
                                  fill: "#0E0F12",
                                },
                              }),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              }),
              _vm._v(" "),
              _vm.dataContainer1.categories[0]
                ? _vm._l(
                    _vm.dataContainer1.categories[0].siblingCount -
                      _vm.dataContainer1.categories.length,
                    function (number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder",
                          style: { width: Math.random() * 20 + 60 + "%" },
                        }),
                      ])
                    }
                  )
                : _vm.dataContainer1.parent
                ? _vm._l(
                    _vm.dataContainer1.parent.childCount,
                    function (number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder",
                          style: { width: Math.random() * 20 + 60 + "%" },
                        }),
                      ])
                    }
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu",
              attrs: { id: "menu-2" },
            },
            [
              _vm.dataContainer2.parent
                ? _c(
                    "li",
                    {
                      staticClass: "ddown",
                      on: {
                        click: function ($event) {
                          return _vm.slideTo(
                            (_vm.dataContainer2.parent &&
                              _vm.dataContainer2.parent.parent) ||
                              null,
                            true
                          )
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "nav-direction btn-up" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "14",
                              height: "12",
                              viewBox: "0 0 14 12",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M12.6663 5.71396L2.27567 5.71396L5.85167 2.13796C6.112 1.87762 6.112 1.45546 5.85184 1.19529C5.5915 0.934957 5.16917 0.934957 4.90884 1.19529L0.195003 5.90929C0.164003 5.94029 0.136338 5.97446 0.112004 6.01079C0.100837 6.02763 0.0930028 6.04579 0.0833363 6.06329C0.0723367 6.08396 0.05967 6.10363 0.050837 6.12546C0.0413365 6.14796 0.0360036 6.17129 0.0293374 6.19463C0.0238366 6.21313 0.0166707 6.23079 0.0128369 6.24979C0.00417089 6.29313 -0.000330446 6.33679 -0.000330442 6.38063C-0.000330442 6.38113 -0.000163549 6.38163 -0.000163549 6.38213C3.34821e-06 6.42529 0.00433685 6.46863 0.012837 6.51113C0.0168367 6.53113 0.0243364 6.54963 0.03017 6.56929C0.0366702 6.59146 0.0416703 6.61396 0.0506702 6.63546C0.0603366 6.65863 0.0733371 6.67963 0.0853372 6.70146C0.094337 6.71779 0.101503 6.73446 0.111836 6.75013C0.13617 6.78696 0.164171 6.82129 0.195338 6.85246L4.90901 11.566C5.16934 11.8263 5.59151 11.8263 5.85184 11.5661C6.11217 11.3058 6.11217 10.8836 5.85184 10.6231L2.27584 7.04729L12.6663 7.04729C13.0345 7.04729 13.333 6.74879 13.333 6.38062C13.333 6.01246 13.0345 5.71396 12.6663 5.71396Z",
                                fill: "#F0C42E",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M12.6663 4.71396L2.27567 4.71396L5.85167 1.13796C6.112 0.877623 6.112 0.455457 5.85184 0.19529C5.5915 -0.0650428 5.16917 -0.0650427 4.90884 0.19529L0.195003 4.90929C0.164003 4.94029 0.136338 4.97446 0.112004 5.01079C0.100837 5.02763 0.0930028 5.04579 0.0833363 5.06329C0.0723367 5.08396 0.05967 5.10363 0.050837 5.12546C0.0413365 5.14796 0.0360036 5.17129 0.0293374 5.19463C0.0238366 5.21313 0.0166707 5.23079 0.0128369 5.24979C0.00417089 5.29313 -0.000330446 5.33679 -0.000330442 5.38063C-0.000330442 5.38113 -0.000163549 5.38163 -0.000163549 5.38213C3.34821e-06 5.42529 0.00433685 5.46863 0.012837 5.51113C0.0168367 5.53113 0.0243364 5.54963 0.03017 5.56929C0.0366702 5.59146 0.0416703 5.61396 0.0506702 5.63546C0.0603366 5.65863 0.0733371 5.67963 0.0853372 5.70146C0.094337 5.71779 0.101503 5.73446 0.111836 5.75013C0.13617 5.78696 0.164171 5.82129 0.195338 5.85246L4.90901 10.566C5.16934 10.8263 5.59151 10.8263 5.85184 10.5661C6.11217 10.3058 6.11217 9.88363 5.85184 9.62313L2.27584 6.04729L12.6663 6.04729C13.0345 6.04729 13.333 5.74879 13.333 5.38062C13.333 5.01246 13.0345 4.71396 12.6663 4.71396Z",
                                fill: "#0E0F12",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        typeof _vm.dataContainer2.parent.details !== "undefined"
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.dataContainer2.parent.details[0].name
                                )
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataContainer2.categories, function (category) {
                return _c("li", { staticClass: "ddown" }, [
                  _c(
                    "a",
                    { attrs: { href: _vm.getCategoryUrl(category.url) } },
                    [_vm._v(_vm._s(category.details[0].name))]
                  ),
                  _vm._v(" "),
                  category.childCount
                    ? _c(
                        "span",
                        {
                          staticClass: "nav-direction",
                          on: {
                            click: function ($event) {
                              return _vm.slideTo(category)
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "9",
                                height: "11",
                                viewBox: "0 0 6 8",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M5.43617 4.38461L2.44086 7.37992C2.16617 7.65461 1.7168 7.65461 1.44242 7.37992L1.19211 7.12992C0.917734 6.85586 0.917734 6.40617 1.19211 6.1318L3.47805 3.84586L1.19211 1.55961C0.917734 1.28523 0.917734 0.835547 1.19211 0.561485L1.44242 0.311484C1.7168 0.036797 2.16617 0.036797 2.44086 0.311484L5.43617 3.30742C5.58367 3.45461 5.6493 3.65242 5.63836 3.84586C5.6493 4.0393 5.58367 4.2368 5.43617 4.38461Z",
                                  fill: "#0E0F12",
                                },
                              }),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              }),
              _vm._v(" "),
              _vm.dataContainer2.categories[0]
                ? _vm._l(
                    _vm.dataContainer2.categories[0].siblingCount -
                      _vm.dataContainer2.categories.length,
                    function (number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder",
                          style: { width: Math.random() * 20 + 60 + "%" },
                        }),
                      ])
                    }
                  )
                : _vm.dataContainer2.parent
                ? _vm._l(
                    _vm.dataContainer2.parent.childCount,
                    function (number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder",
                          style: { width: Math.random() * 20 + 60 + "%" },
                        }),
                      ])
                    }
                  )
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      !_vm.isNavigationInitialized
        ? [
            _c("ul", { staticClass: "breadcrumb" }, [
              _c("li", {
                staticClass: "btn-close",
                on: {
                  click: function ($event) {
                    return _vm.closeNavigation()
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(0),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "loading" }, [_c("loading-animation")], 1),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "breadcrumb-item" }, [
      _c("i", { staticClass: "fa fa-home", attrs: { "aria-hidden": "true" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }